import { useContext, useState } from "react";
import { AuthEmpleadoContext } from "../../../context/AuthEmpleadoContext";
import { useNavigate } from "react-router-dom";
import img1 from "../../../assets/images/logo colegio (32).png";

function HeaderEmpleado() {
  const { empleado, logoutEmpleado } = useContext(AuthEmpleadoContext);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  if (!empleado) return null;

  const cerrarSesion = () => {
    setOpen(false);
    logoutEmpleado();
    navigate("/loginEmpleados");
  };

  return (
    <nav
      className="navbar sticky-top px-3 shadow"
      style={{ background: "rgb(61, 102, 81)" }}
    >
      <div className="container-fluid d-flex align-items-center justify-content-between">
        <div
          className="d-flex align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/dashboardEmpleados")}
        >
          <img
            src={img1}
            alt="Logo Colegio"
            style={{ height: "60px", width: "auto" }}
          />
          <div className="ms-3 text-home">
            <h1 className="mb-0 mt-2" id="texto-nav-homecolegio">
              Colegio Santo Tomás
            </h1>
            <p className="mb-0 text-center" id="texto-nav-home">
              Portal de Empleados
            </p>
          </div>
        </div>

        <div className="position-relative">
          <button
            type="button"
            className="btn text-white fw-semibold"
            style={{
              background: "rgba(255,255,255,0.15)",
              borderRadius: "20px",
            }}
            onClick={() => setOpen((prev) => !prev)}
          >
            👤 {empleado.nombre} {empleado.apellido}
          </button>

          {open && (
            <div
              className="dropdown-menu dropdown-menu-end show shadow empleado-dropdown-menu"
              style={{ position: "absolute", right: 0 }}
            >
              <button
                type="button"
                className="dropdown-item empleado-dropdown-item"
                onClick={() => {
                  setOpen(false);
                  navigate("/dashboardEmpleados");
                }}
              >
                🏠 Dashboard
              </button>

              <button
                type="button"
                className="dropdown-item empleado-dropdown-item"
                onClick={() => {
                  setOpen(false);
                  navigate("/misRecibos");
                }}
              >
                📄 Mis recibos
              </button>

              <button
                type="button"
                className="dropdown-item empleado-dropdown-item"
                onClick={() => {
                  setOpen(false);
                  navigate("/perfilEmpleado");
                }}
              >
                👁 Ver perfil
              </button>

              <button
                type="button"
                className="dropdown-item empleado-dropdown-item"
                onClick={() => {
                  setOpen(false);
                  navigate("/cambiar-password");
                }}
              >
                🔒 Cambiar contraseña
              </button>

              <hr className="dropdown-divider" />
              <button
                type="button"
                className="dropdown-item text-danger empleado-dropdown-item"
                onClick={cerrarSesion}
              >
                🚪 Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default HeaderEmpleado;
